import { createReducer } from 'reduxsauce';
import actions from './actions';

const { Types } = actions;
const INITIAL_STATE = {
  isRequesting: false,
  dropdownDetails: {},
  isSubmitContactLoading: false,
  contactUsDetails: {},
  error: null,
};

const request = (state = INITIAL_STATE) => {
  return {
    ...state,
    isRequesting: true,
    error: null,
  };
};

const loadDropdownDataSuccess = (state = INITIAL_STATE, { dropdownDetails }) => {
  return {
    ...state,
    isRequesting: false,
    dropdownDetails,
  };
};

const failure = (state = INITIAL_STATE, { error }) => {
  return {
    ...state,
    isRequesting: false,
    dropdownDetails: {},
    error,
  };
};

const submitContactRequest = (state = INITIAL_STATE) => {
  return {
    ...state,
    isSubmitContactLoading: true,
    error: null,
  };
};

const submitContactSuccess = (state = INITIAL_STATE, { contactUsDetails }) => {
  return {
    ...state,
    isSubmitContactLoading: false,
    contactUsDetails,
  };
};

const submitContactFailure = (state = INITIAL_STATE, { error }) => {
  return {
    ...state,
    isSubmitContactLoading: false,
    contactUsDetails: {},
    error,
  };
};

export const HANDLERS = {
  [Types.LOAD_DROPDOWN_DATA_REQUEST]: request,
  [Types.LOAD_DROPDOWN_DATA_SUCCESS]: loadDropdownDataSuccess,
  [Types.LOAD_DROPDOWN_DATA_FAILURE]: failure,

  [Types.SUBMIT_CONTACT_REQUEST]: submitContactRequest,
  [Types.SUBMIT_CONTACT_SUCCESS]: submitContactSuccess,
  [Types.SUBMIT_CONTACT_FAILURE]: submitContactFailure,
};

export default createReducer(INITIAL_STATE, HANDLERS);
